<template>
  <sistema>
    <container>
      <template v-slot:header>
        <h3>Dashboard</h3>
      </template>
      <template v-slot:body>
        <div>
          <formgrid>
            <p>
              Robo Consulta:
              <span
                :style="{ color: state.responseConsulta ? 'green' : 'red' }"
              >
                {{ state.responseConsulta ? "Ligado" : "Desligado" }}
              </span>
              <span style="margin-left: 2rem;">
                Robo Cadastro:
                <span
                  :style="{ color: state.responseCadastro ? 'green' : 'red' }"
                >
                  {{ state.responseCadastro ? "Ligado" : "Desligado" }}
                </span>
              </span>
            </p>
          </formgrid>
          <button-group style="margin-right: 1rem;">
            <Button
              type="submit"
              class="p-button-rounded p-button-success"
              label="Ligar Robo Consulta"
              @click="executeLigarRoboConsulta"
            />
            <Button
              label="Desligar Robo Consulta"
              class="p-button-rounded p-button-danger"
              @click="executeDesligarRoboConsulta"
            />
          </button-group>
          <button-group>
            <Button
              type="submit"
              class="p-button-rounded p-button-success"
              label="Ligar Robo Cadastro"
              @click="executeLigarRoboCadastro"
            />
            <Button
              label="Desligar Robo Cadastro"
              class="p-button-rounded p-button-danger"
              @click="executeDesligarRoboCadastro"
            />
          </button-group>
          <div>
            <p>
              Saldo AntiCaptcha:
              {{ state.saldoAntiCaptcha }}$
            </p>
            <p>
              Saldo Hcaptcha:
              {{ state.saldoHcaptcha }} Tokens
            </p>
          </div>
          <Panel
            class="controle-orgao-panel"
            header="Controle de Robôs por Órgão"
            :toggleable="true"
            :collapsed="true"
          >
            <DataTable
              class="p-datatable-sm"
              responsiveLayout="stack"
              breakpoint="60rem"
              :stripedRows="true"
              :loading="state.loadingOrgaos"
              :value="state.orgaosRobo"
            >
              <Column field="sigla" header="Órgão">
                <template #body="{ data }">
                  <div class="orgao-cell">
                    <span class="orgao-logo">
                      <orgao-aet-img :idOrgao="data.idOrgao" />
                    </span>
                    <span :class="orgaoStatusClass(data)">
                      {{ data.sigla }} - {{ data.nome }}
                    </span>
                  </div>
                </template>
              </Column>
              <Column header="Consulta" style="width: 8rem;">
                <template #body="{ data }">
                  <InputSwitch
                    :modelValue="data.consultaHabilitado"
                    @update:modelValue="(v) => toggleConsultaOrgao(data, v)"
                  />
                </template>
              </Column>
              <Column header="Cadastro" style="width: 8rem;">
                <template #body="{ data }">
                  <InputSwitch
                    :modelValue="data.cadastroHabilitado"
                    @update:modelValue="(v) => toggleCadastroOrgao(data, v)"
                  />
                </template>
              </Column>
            </DataTable>
          </Panel>
          <DataTable
            class="p-datatable-sm fila-robos-table"
            responsiveLayout="stack"
            breakpoint="60rem"
            :stripedRows="true"
            :value="state.results.content"
          >
            <template #header>
              <div class="search-result-header">
                <div class="search-result-header-actions">
                  <Button
                    icon="pi pi-refresh"
                    class="p-button-rounded p-button-text"
                    :loading="state.loadingFila"
                    v-title="'Atualizar'"
                    @click="executeSearchFilaRobo"
                  />
                  <span class="search-result-title">Fila de Robôs</span>
                </div>
                <span
                  v-if="state.results.page.totalElements"
                  class="search-result-count"
                >
                  {{ state.results.page.totalElements }} registro{{
                    state.results.page.totalElements !== 1 ? "s" : ""
                  }}
                </span>
              </div>
            </template>
            <Column style="white-space: pre-line;" field="fila" header="Fila">
              <template #body="{ data }">
                {{ getFila(data) }}
              </template>
            </Column>
            <Column style="white-space: pre-line;" field="sigla" header="Sigla">
              <template #body="{ data }">
                <div class="orgao-cell">
                  <span class="orgao-logo">
                    <orgao-aet-img
                      v-if="getIdOrgaoAetBySigla(getSigla(data))"
                      :idOrgao="getIdOrgaoAetBySigla(getSigla(data))"
                    />
                    <orgao-art-img
                      v-else-if="getIdOrgaoArtBySigla(getSigla(data))"
                      :idOrgao="getIdOrgaoArtBySigla(getSigla(data))"
                    />
                  </span>
                  <span>{{ getSigla(data) }}</span>
                </div>
              </template>
            </Column>
            <Column
              style="white-space: pre-line;"
              field="statusRobo"
              header="Status Robo"
            >
              <template #body="{ data }">
                {{ getStatusRobo(data) }}
              </template>
            </Column>
            <Column
              style="white-space: pre-line;"
              field="qtde"
              header="Quantidade"
            >
              <template #body="{ data }">
                {{ getQuantidade(data) }}
              </template>
            </Column>
          </DataTable>
          <div>
            <crud-art-engenheiro-transportador label="Fila ARTS" />
          </div>
        </div>
      </template>
    </container>
  </sistema>
</template>

<script lang="ts">
import { useAuth, PermissionPayload } from "../../modules/auth";
import CrudArtEngenheiroTransportador from "../../components/transportador/art/CrudArtEngenheiroTransportador.vue";
import {
  useDashboardService,
  DashboarPayload,
  OrgaoRoboStatusPayload
} from "../../modules/business/cliente/dashboardBusiness";
import { defineComponent, reactive, onMounted } from "vue";
import { useToast } from "../../modules/message";
import { PaginationResult, defaultResults } from "../../pagination";
import {
  useOrgaoAetService,
  useOrgaoArtService
} from "../../modules/business/common/commonBusiness";

interface DashboardState {
  entity: DashboarPayload | null;
  page: number;
  responseConsulta: boolean;
  responseCadastro: boolean;
  saldoAntiCaptcha: string | null;
  saldoHcaptcha: string | null;
  results: PaginationResult<DashboarPayload>;
  loadingFila: boolean;
  orgaosRobo: OrgaoRoboStatusPayload[];
  loadingOrgaos: boolean;
}

export default defineComponent({
  components: {
    CrudArtEngenheiroTransportador
  },
  setup() {
    const state = reactive<DashboardState>({
      entity: null,
      page: 0,
      responseConsulta: false,
      responseCadastro: false,
      saldoAntiCaptcha: null,
      saldoHcaptcha: null,
      results: defaultResults(),
      loadingFila: false,
      orgaosRobo: [],
      loadingOrgaos: false
    });

    const dashboardService = useDashboardService();

    const amIAllowed = (
      authority: string,
      permissionInfo?: PermissionPayload | string | null
    ) => {
      return useAuth().amIAllowed(authority, permissionInfo);
    };

    const executeBuscaSaldoAntiCaptcha = async () => {
      try {
        await dashboardService.getSaldoAntiCaptcha();
        const saldoResponse = dashboardService.data.value;
        const saldo = saldoResponse.balance;
        state.saldoAntiCaptcha = saldo;
        return saldo;
      } catch (error) {
        useToast().error("Falha ao buscar saldo AntiCaptcha");
        return null;
      }
    };

    const executeBuscaSaldoHcaptcha = async () => {
      try {
        await dashboardService.getSaldoHcaptcha();
        const saldoResponse = dashboardService.data.value;
        const saldo = saldoResponse.saldo;
        state.saldoHcaptcha = saldo;
        return saldo;
      } catch (error) {
        useToast().error("Falha ao buscar saldo Hcaptcha");
        return null;
      }
    };

    const executeBuscaStatusConsulta = async () => {
      await dashboardService.isRoboConsultaHabilitado();
      const consultaResponse = dashboardService.data.value;
      state.responseConsulta = consultaResponse;
      return consultaResponse;
    };

    const executeBuscaStatusCadastro = async () => {
      await dashboardService.isRoboCadastroHabilitado();
      const cadastroResponse = dashboardService.data.value;
      state.responseCadastro = cadastroResponse;
      return cadastroResponse;
    };

    const executeDesligarRoboConsulta = async () => {
      try {
        await useDashboardService().desligarRoboConsulta();
        useToast().success("Robos desligados com sucesso");
        executeBuscaStatusConsulta();
      } catch {
        useToast().error("Falha ao desligar os Robos");
      }
    };

    const executeLigarRoboConsulta = async () => {
      try {
        await useDashboardService().ligarRoboConsulta();
        useToast().success("Robos ligados com sucesso");
        executeBuscaStatusConsulta();
      } catch {
        useToast().error("Falha ao ligar os Robos");
      }
    };

    const executeDesligarRoboCadastro = async () => {
      try {
        await useDashboardService().desligarRoboCadastro();
        useToast().success("Robos desligados com sucesso");
        executeBuscaStatusCadastro();
      } catch {
        useToast().error("Falha ao desligar os Robos");
      }
    };

    const executeLigarRoboCadastro = async () => {
      try {
        await useDashboardService().ligarRoboCadastro();
        useToast().success("Robos ligados com sucesso");
        executeBuscaStatusCadastro();
      } catch {
        useToast().error("Falha ao ligar os Robos");
      }
    };

    const executeSearchFilaRobo = () => {
      const { data, getDadosFilaRobo } = useDashboardService();
      state.loadingFila = true;
      return getDadosFilaRobo(state.page)
        .then(() => {
          if (data.value && data.value.content) {
            const resultTratado: DashboarPayload[] = data.value.content.map(
              (item: DashboarPayload, index: number) => {
                item.groupIndex = index;
                return item;
              }
            );
            data.value.content = resultTratado;
            state.results = data.value;
          } else {
            state.results = defaultResults();
          }
        })
        .finally(() => {
          state.loadingFila = false;
        });
    };

    const executeBuscaOrgaosRobo = () => {
      const { data, getOrgaosRoboStatus } = useDashboardService();
      state.loadingOrgaos = true;
      return getOrgaosRoboStatus()
        .then(() => {
          state.orgaosRobo = Array.isArray(data.value) ? data.value : [];
        })
        .finally(() => {
          state.loadingOrgaos = false;
        });
    };

    const orgaoStatusClass = (orgao: OrgaoRoboStatusPayload) => {
      const consulta = !!orgao.consultaHabilitado;
      const cadastro = !!orgao.cadastroHabilitado;
      if (consulta && cadastro) {
        return "orgao-status-on";
      }
      if (!consulta && !cadastro) {
        return "orgao-status-off";
      }
      return "orgao-status-mixed";
    };

    const toggleConsultaOrgao = (
      orgao: OrgaoRoboStatusPayload,
      valor: boolean
    ) => {
      if (!orgao.idOrgao) {
        return;
      }
      const service = useDashboardService();
      const acao = valor
        ? service.ligarRoboConsultaOrgao(orgao.idOrgao)
        : service.desligarRoboConsultaOrgao(orgao.idOrgao);
      acao
        .then(() => {
          useToast().success(
            `Robô de Consulta ${valor ? "ligado" : "desligado"} para ${
              orgao.sigla
            }`
          );
        })
        .finally(() => {
          executeBuscaOrgaosRobo();
        });
    };

    const toggleCadastroOrgao = (
      orgao: OrgaoRoboStatusPayload,
      valor: boolean
    ) => {
      if (!orgao.idOrgao) {
        return;
      }
      const service = useDashboardService();
      const acao = valor
        ? service.ligarRoboCadastroOrgao(orgao.idOrgao)
        : service.desligarRoboCadastroOrgao(orgao.idOrgao);
      acao
        .then(() => {
          useToast().success(
            `Robô de Cadastro ${valor ? "ligado" : "desligado"} para ${
              orgao.sigla
            }`
          );
        })
        .finally(() => {
          executeBuscaOrgaosRobo();
        });
    };

    const getIdOrgaoAetBySigla = (sigla?: string | null) => {
      if (!sigla) {
        return null;
      }
      return (
        useOrgaoAetService()
          .getOrgaosAet()
          .find((o) => o.sigla === sigla)?.idOrgao ?? null
      );
    };

    const getIdOrgaoArtBySigla = (sigla?: string | null) => {
      if (!sigla) {
        return null;
      }
      return (
        useOrgaoArtService()
          .getOrgaosArt()
          .find((o) => o.sigla === sigla)?.idOrgao ?? null
      );
    };

    const getFila = (e?: DashboarPayload) => {
      return useDashboardService().getFila(e);
    };

    const getSigla = (e?: DashboarPayload) => {
      return useDashboardService().getSigla(e);
    };

    const getStatusRobo = (e?: DashboarPayload) => {
      return useDashboardService().getStatusRobo(e);
    };

    const getQuantidade = (e?: DashboarPayload) => {
      return useDashboardService().getQuantidade(e);
    };

    onMounted(() => {
      executeBuscaStatusCadastro();
      executeBuscaStatusConsulta();
      executeSearchFilaRobo();
      executeBuscaOrgaosRobo();
      executeBuscaSaldoAntiCaptcha();
      executeBuscaSaldoHcaptcha();
    });

    return {
      state,
      amIAllowed,
      executeBuscaStatusCadastro,
      executeBuscaStatusConsulta,
      executeDesligarRoboConsulta,
      executeLigarRoboConsulta,
      executeDesligarRoboCadastro,
      executeLigarRoboCadastro,
      executeBuscaSaldoHcaptcha,
      executeBuscaSaldoAntiCaptcha,
      executeSearchFilaRobo,
      executeBuscaOrgaosRobo,
      orgaoStatusClass,
      getIdOrgaoAetBySigla,
      getIdOrgaoArtBySigla,
      toggleConsultaOrgao,
      toggleCadastroOrgao,
      getFila,
      getSigla,
      getStatusRobo,
      getQuantidade
    };
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.fila-robos-table {
  margin-bottom: $space-4;
}

.search-result-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.search-result-header-actions {
  display: flex;
  align-items: center;
  gap: $space-3;
}

.search-result-title {
  font-size: $font-size-base;
  font-weight: $font-weight-semibold;
  color: $text-primary;
}

.search-result-count {
  font-size: $font-size-xs;
  color: $text-muted;
  background: $bg-surface-secondary;
  padding: $space-1 $space-3;
  border-radius: $radius-full;
  white-space: nowrap;
}

.controle-orgao-panel {
  margin-bottom: $space-4;
}

.orgao-cell {
  display: flex;
  align-items: center;
  gap: $space-2;
}

.orgao-logo {
  flex: 0 0 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.orgao-status-on {
  color: $success;
  font-weight: $font-weight-semibold;
}

.orgao-status-mixed {
  color: $warning;
  font-weight: $font-weight-semibold;
}

.orgao-status-off {
  color: $danger;
  font-weight: $font-weight-semibold;
}
</style>
